<template>
<!-- 申报新物资 -->
    <div class="declare-view">
        <div class="table-title">
            <Row type="flex">
                <div class="boxs-div">
                    <span class="input-label">物资分类：</span>
                    <span class="Cascader">
                        <Cascader
                            :data="productClassifyData"
                            v-model="productClassify"
                            @on-change="productClassifyChange"></Cascader>
                    </span>
                </div>
                <div class="boxs-div" style="margin-left: 20px">
                    <span class="input-label">物资名称：</span>
                    <span class="Cascader">
                        <Input placeholder="物资名称"
                            v-model="productByClassifyVar.productName"/>
                    </span>
                    <Button
                        style="margin-left: 16px"
                        type="primary"
                        @click="handleSearch">
                        搜索
                    </Button>
                    <Button
                        style="margin-left: 16px"
                        @click="handleReset">
                        重置
                    </Button>
                </div>
            </Row>
        </div>
        <div>
            <Button class="operation-btn" @click="handleCreate(1)">申报新物资</Button>
            <Button class="operation-btn" @click="handleCreate(2)" style="margin-left: 20px">申请记录</Button>
            <Table
                :columns="columns"
                :data="list"
                :height="520"
                ref="list">
                <template slot-scope="{ row }" slot="action">
                    <Button size="small" @click="addSpec(row)">新增规格</Button>
                </template>
            </Table>
            <div class="pages-footer">
                <Page
                    :current="productByClassifyVar.pageNumber"
                    :total="listTotal"
                    show-sizer
                    :page-size="productByClassifyVar.pageSize"
                    @on-page-size-change="getChangePageSize"
                    @on-change="getChangePageNum"/>
            </div>
        </div>
    </div>
</template>

<script>
import { queryProductClassify, queryProductByClassifyNo } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
import { creatMultidimensionalArray } from '@/assets/js/creatArr.js';

export default {
    beforeRouteEnter(to, from, next) {
        if (from.path !== '/index/addSpec') {
            window.sessionStorage.removeItem('crowInfoClassify');
            window.sessionStorage.removeItem('crowInfo');
            window.sessionStorage.removeItem('cpageInfo');
        }
        next();
    },
    data() {
        return {
            productClassify: [],
            productClassifyData: [],
            productName: '',
            productByClassifyVar: {
                pageNumber: 1,
                pageSize: 20,
                classifyNo: '',
                cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                productName: '' // 物资名称
            },
            list: [],
            listTotal: 0,
            columns: [
                {
                    title: '物资名称',
                    key: 'productname',
                    minWidth: 100
                },
                {
                    title: '物资编码',
                    key: 'productspu',
                    minWidth: 120
                },
                {
                    title: '物资分类',
                    key: 'classifyname',
                    minWidth: 120
                },
                {
                    title: '物资规格',
                    key: 'productspectype',
                    minWidth: 100
                },
                {
                    title: '物资单位',
                    key: 'productunit',
                    minWidth: 100
                },
                {
                    title: '物资描述',
                    key: 'productspec',
                    minWidth: 100
                },
                {
                    title: '操作',
                    slot: 'action',
                    minWidth: 100
                }
            ],
            pageInfo: {
                classify: []
            }
        };
    },
    mounted() {
        this.getProductClassify();
        if (window.sessionStorage.getItem('cpageInfo')) {
            const crowInfoClassify = JSON.parse(window.sessionStorage.getItem('crowInfoClassify'));
            this.productClassify = crowInfoClassify;
            this.productByClassifyVar = JSON.parse(window.sessionStorage.getItem('cpageInfo'));
        }
        this.getProductByClassifyNo();
    },
    methods: {
        handleCreate(ty) {
            if (ty === 1) {
                this.$router.push('/index/declare-create');
            } else {
                this.$router.push('/index/declare-record');
            }
        },
        // 新增规格
        addSpec(row) {
            this.$router.push({
                path: '/index/addSpec',
                query: {
                    spu: row.productspu
                }
            });
            window.sessionStorage.setItem('crowInfoClassify', JSON.stringify(this.pageInfo.classify));
            window.sessionStorage.setItem('crowInfo', JSON.stringify(row));
            window.sessionStorage.setItem('cpageInfo', JSON.stringify(this.productByClassifyVar));
        },
        // 获取物资分类的联级列表
        getProductClassify() {
            this.$apollo.query({
                query: queryProductClassify,
                variables: {
                    cliqueNo: `${Cookies.getJSON('cliqueNo')}`,
                    supplierNo: `${Cookies.getJSON('USER-INFO').supplierNo}`
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductClassify;
                if (data && data.data && data.code === 200) {
                    let parentData = [];
                    for (let i = 5;i > 0;i -= 1) {
                        if (data.data[i.toString()].length) {
                            parentData = creatMultidimensionalArray(
                                data.data[i.toString()],
                                parentData,
                                'classifyParentNo',
                                'classifyName',
                                'classifyNo'
                            );
                        } else {
                            continue;
                        }
                    }
                    parentData.forEach(ele => {
                        let classifyName, classifyNo, children, value, label;
                        ({ classifyName: label, classifyNo: value, children } = ele);
                        this.productClassifyData.push({
                            value,
                            label,
                            children
                        });
                    });
                } else {
                    this.$setNotice('分类列表获取失败，刷新试试吧');
                }
            });
        },
        // 获取物资列表
        getProductByClassifyNo() {
            this.$apollo.query({
                query: queryProductByClassifyNo,
                variables: this.productByClassifyVar,
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductByClassifyNo;
                if (data && data.data && data.code === 200) {
                    this.listTotal = data.count;
                    this.list = data.data;
                }
            });
        },
        handleSearch() {
            this.productByClassifyVar.pageNumber = 1;
            this.getProductByClassifyNo();
        },
        handleReset() {
            this.productByClassifyVar.pageNumber = 1;
            this.productByClassifyVar.productName = '';
            this.productByClassifyVar.classifyNo = '';
            this.productClassify = [];
            this.getProductByClassifyNo();
        },
        // 选中物资分类
        productClassifyChange(val) {
            this.pageInfo.classify = val;
            this.productByClassifyVar.productName = '';
            this.productByClassifyVar.classifyNo = val[val.length - 1] || '';
        },
        getChangePageNum(val) {
            this.productByClassifyVar.pageNumber = val;
            this.getProductByClassifyNo();
        },

        // pagesize 变化
        getChangePageSize(size) {
            this.productByClassifyVar.pageSize = size;
            this.getProductByClassifyNo();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/declare/index.vue